let initialized = false;
let activeModal = null;
let previousFocus = null;
let previousBodyOverflow = '';
let closeTimer = null;
const mobileQuery = window.matchMedia('(max-width: 479px)');
const mobileCloseDuration = 360;

function getOverlay() {
  return document.querySelector('.l-overlay__modals') || document.querySelector('.l-overlay');
}

function openModal(modal) {
  if (!modal) return;

  if (closeTimer) {
    window.clearTimeout(closeTimer);
    closeTimer = null;
  }

  if (modal.parentElement !== document.body) {
    document.body.appendChild(modal);
  }

  activeModal = modal;
  previousFocus = document.activeElement;
  previousBodyOverflow = document.body.style.overflow;

  document.body.style.overflow = 'hidden';
  modal.classList.remove('js-modal-closing');
  modal.setAttribute('aria-hidden', 'false');

  const overlay = getOverlay();
  if (overlay) {
    overlay.dataset.activeModal = modal.id;
    overlay.style.display = 'block';
  }

  if (mobileQuery.matches) {
    modal.offsetHeight;
    window.requestAnimationFrame(() => {
      modal.classList.add('js-modal-show');
    });
  } else {
    modal.classList.add('js-modal-show');
  }

  modal.querySelector('[data-product-info-modal-close], [data-lifetime-guarantee-close]')?.focus();
}

function closeModal(modal = activeModal) {
  if (!modal) return;

  const shouldAnimateMobileClose = mobileQuery.matches && modal.classList.contains('js-modal-show');

  modal.classList.remove('js-modal-show');
  modal.setAttribute('aria-hidden', 'true');

  if (shouldAnimateMobileClose) {
    modal.classList.add('js-modal-closing');
    closeTimer = window.setTimeout(() => {
      closeTimer = null;
      finishClose(modal);
    }, mobileCloseDuration);

    return;
  }

  finishClose(modal);
}

function finishClose(modal) {
  modal.classList.remove('js-modal-closing');
  document.body.style.overflow = previousBodyOverflow;

  const overlay = getOverlay();
  if (overlay && overlay.dataset.activeModal === modal.id) {
    delete overlay.dataset.activeModal;
    overlay.style.display = '';
  }

  previousFocus?.focus?.();
  activeModal = null;
  previousFocus = null;
}

export function initLifetimeGuaranteeModal() {
  if (initialized) return;
  initialized = true;

  document.addEventListener(
    'click',
    (event) => {
      const opener = event.target.closest('[data-product-info-modal-open], [data-lifetime-guarantee-open]');
      if (opener) {
        const modalId = opener.getAttribute('data-product-info-modal-open') || opener.getAttribute('data-lifetime-guarantee-open');
        const modal = modalId ? document.getElementById(modalId) : null;

        if (modal) {
          event.preventDefault();
          openModal(modal);
        }

        return;
      }

      const closer = event.target.closest('[data-product-info-modal-close], [data-lifetime-guarantee-close]');
      if (closer) {
        event.preventDefault();
        closeModal(closer.closest('[data-product-info-modal], [data-lifetime-guarantee-modal]'));
        return;
      }

      if (activeModal && event.target === activeModal) {
        event.preventDefault();
        closeModal(activeModal);
      }
    },
    true
  );

  document.addEventListener('click', (event) => {
    if (activeModal && event.target === getOverlay()) {
      closeModal(activeModal);
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && activeModal) {
      closeModal(activeModal);
    }
  });
}
